export const sortByTextCol = (column) => (a, b) =>
  a[column].localeCompare(b[column]);
export const sortByNumCol = (column) => (a, b) => a[column] - b[column];
